import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "p-dialog-titlebar p-dialog-titlebar-icon" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-eye" }, null, -1)
const _hoisted_3 = {
  class: "p-mb-2 p-mt-1 p-text-bold p-text-uppercase",
  style: {"color":"#004c97"}
}
const _hoisted_4 = { class: "p-grid" }
const _hoisted_5 = { class: "p-col" }
const _hoisted_6 = { class: "p-mr-2 p-text-uppercase" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("b", null, " FROM : ", -1)
const _hoisted_8 = { class: "p-mx-2 p-text-uppercase" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("b", null, " Receipt NO : ", -1)
const _hoisted_10 = { class: "p-mx-2 p-text-uppercase" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("b", null, " RECEIPT DATE : ", -1)
const _hoisted_12 = {
  key: 0,
  class: "p-mx-2 p-text-uppercase"
}
const _hoisted_13 = /*#__PURE__*/_createElementVNode("b", null, " DUE DATE : ", -1)
const _hoisted_14 = { class: "p-mx-2 p-text-uppercase" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("b", null, " TOTAL BALANCE : ", -1)
const _hoisted_16 = { class: "p-grid" }
const _hoisted_17 = { class: "p-col-12" }
const _hoisted_18 = { class: "form-group" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("label", { for: "paymentMethod" }, "Payment Method", -1)
const _hoisted_20 = { class: "p-col-12" }
const _hoisted_21 = { class: "form-group" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("label", { for: "paymentMethod" }, "Amount", -1)
const _hoisted_23 = { class: "p-col-12" }
const _hoisted_24 = { class: "p-field" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("label", { for: "description" }, "Description", -1)
const _hoisted_26 = { class: "p-col-12" }
const _hoisted_27 = { class: "form-group" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_InputNumber = _resolveComponent("InputNumber")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createBlock(_component_Dialog, {
    id: "previewReceiptDailog",
    visible: _ctx.productDialog,
    "onUpdate:visible": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.productDialog) = $event)),
    style: { width: '60vw' },
    position: "top",
    class: "p-fluid",
    modal: true,
    closable: true,
    onHide: _ctx.closeDialog
  }, {
    header: _withCtx(() => [
      _createElementVNode("h5", _hoisted_1, [
        _hoisted_2,
        _createTextVNode(" " + _toDisplayString(_ctx.dialogTitle), 1)
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("h3", _hoisted_3, _toDisplayString(_ctx.previewHeading), 1),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("span", _hoisted_6, [
            _hoisted_7,
            _createTextVNode(" " + _toDisplayString(_ctx.item.selectedProfile), 1)
          ]),
          _createElementVNode("span", _hoisted_8, [
            _hoisted_9,
            _createTextVNode(" " + _toDisplayString(_ctx.item.receiptNO), 1)
          ]),
          _createElementVNode("span", _hoisted_10, [
            _hoisted_11,
            _createTextVNode(" " + _toDisplayString(_ctx.formatDate(_ctx.item.receiptDate)), 1)
          ]),
          (_ctx.previewHeading == 'Invoice')
            ? (_openBlock(), _createElementBlock("span", _hoisted_12, [
                _hoisted_13,
                _createTextVNode(" " + _toDisplayString(_ctx.formatDate(_ctx.item.receiptDueDate)), 1)
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("span", _hoisted_14, [
            _hoisted_15,
            _createTextVNode(" " + _toDisplayString(_ctx.formatAmount(_ctx.calculateBalance)), 1)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_16, [
        _createElementVNode("div", _hoisted_17, [
          _createElementVNode("div", _hoisted_18, [
            _hoisted_19,
            _createVNode(_component_Dropdown, {
              id: "paymentMethod",
              modelValue: _ctx.item.method,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.item.method) = $event)),
              options: _ctx.methodList,
              optionLabel: "cardName"
            }, null, 8, ["modelValue", "options"])
          ])
        ]),
        _createElementVNode("div", _hoisted_20, [
          _createElementVNode("div", _hoisted_21, [
            _hoisted_22,
            _createVNode(_component_InputNumber, {
              placeholder: "e.g 20",
              modelValue: _ctx.item.totalAmount,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.item.totalAmount) = $event)),
              mode: "decimal",
              maxFractionDigits: 2,
              minFractionDigits: 2
            }, null, 8, ["modelValue"])
          ])
        ]),
        _createElementVNode("div", _hoisted_23, [
          _createElementVNode("div", _hoisted_24, [
            _hoisted_25,
            _createVNode(_component_InputText, {
              id: "description",
              placeholder: "Any description",
              modelValue: _ctx.item.description,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.item.description) = $event))
            }, null, 8, ["modelValue"])
          ])
        ]),
        _createElementVNode("div", _hoisted_26, [
          _createElementVNode("div", _hoisted_27, [
            _createVNode(_component_Button, {
              icon: "pi pi-check-circle",
              disabled: _ctx.item.totalAmount > _ctx.calculateBalance,
              label: "Save",
              class: "p-button-primary",
              onClick: _ctx.saveReceiptPayment
            }, null, 8, ["disabled", "onClick"])
          ])
        ])
      ])
    ]),
    _: 1
  }, 8, ["visible", "onHide"]))
}